var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer shadow"},[_c('div',{staticClass:"info"},[_c('p',[_vm._v("江苏跨界网络发展有限公司 苏ICP备11032112号")])])])
}]

export { render, staticRenderFns }